import React from "react";
import MenuCard from "../../components/menu-card";

export default function StepFour(props) {
  const focus = 4;

  const description = [
    "Interagiere mit dem Modell",
    "Drehe und skaliere das Modell mit der Maus. Je ähnlicher sich zwei Begriffe sind, desto näher liegen die dazugehörigen Punkte beiander."
  ];

  return <MenuCard task={description} focus={focus} />;
}
